/* eslint-disable no-unused-vars */
import React, { Component, useContext, useRef, useCallback } from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import styled from 'styled-components';

import survey from '../../context/survey';

import { Form } from '../../../common/primitive';
import Hidden from '../hidden/Hidden';
import WidgetSequence from './WidgetSequence';
import sendRAT, { ACTION, SCREEN, sendFreeAnswersToRAT } from '../../app/rat';
import ajax, { parseFormDataToQs } from '../../app/ajax';
import api from '../../app/api';
import surveyState from '../../app/surveyState';
import { Broadcast } from '../../../../embedded-type/broadcast';
import Backdrop from '../../../../embedded-type/survey/page/backdrop/Backdrop';
// import WatchResize from '../../component/watch-resize/WatchResize';

// copy from phase1
const StyledSurveyContainer = styled.aside`
  position: relative;
  z-index: 9003;
  text-align: left;
  line-height: normal;
`;

/**
 * survey widget 表示親 component
 * - form tag で wrap します
 * - {@link Hidden} 必須かつユーザー入力しない項目を出力します
 * - {@link WidgetSequence} widget 表示コントロールします
 * - 送信ボタン click 後に `submit`: ajax 送信し -> {@link Thanks} へ移動します + `RAT` 送信します
 * - 送信ボタン click 時に `RAT` 送信します
 * @param {*} state React.Context config.state
 * @param {function} dispatch React.Context config.dispatch
 * @param {boolean} embedded React.Context.survey.state.config.embedded - 埋め込みフラッグ
 * @param {boolean} desktop resize: desktop size flag
 * @param {*} props React.props
 * @return {*} React.node - widget form を返します
 * @constructor
 */
const WidgetForm = ({ state, dispatch, embedded, desktop, ...props }) => {
  // /**
  //  * state {object} - {@link config}.reduce 戻り値
  //  * dispatch {function} - {@link config}.Context state 変更関数 - type 指定を行います
  //  */
  // const { state, dispatch } = useContext(survey.Context);

  const { config, step } = state;

  const formRef = useRef(null);

  // save -> local storage 'answer'
  const saveStorage = useCallback(() => {
    if (surveyState.shouldStoreState()) {
      surveyState.storeAnswer(
        config.expirationPeriod,
        config.enableDisplaySuppressionPerPage
      );
    }
  }, [config.expirationPeriod, config.enableDisplaySuppressionPerPage]);

  // complete - move thanks(step: 99)
  const moveThanks = useCallback(() => {
    state.type = survey.events.UPDATE;
    state.step = 99;
    dispatch(state);
  }, [state, dispatch]);

  // submit action
  const onSubmit = useCallback(
    event => {
      if (event) {
        event.preventDefault();
      }
      // sndRAT - "form_agree" -> "inquiry", "answer"
      sendRAT({
        cId: config.cId.value,
        screen: SCREEN.INQUIRY,
        action: ACTION.ANSWER,
      });
      // formData to qs
      const parsed = parseFormDataToQs(new FormData(formRef.current), config);
      // send async - success / fail 処理同じなので結果(Promise)待たない
      ajax(api({ surveyId: config.surveyId }), parsed);
      // save local storage
      saveStorage();
      // move last
      moveThanks();
      if (embedded) {
        // embedded type - call Redux.store.submit
        Broadcast.submit.complete();
      }
    },
    [saveStorage, moveThanks, config, embedded]
  );

  // widget 「送信する」button callback
  const onSendClick = useCallback(
    textRef => {
      // sendFreeAnswersToRAT
      // cId, textarea value and (nps checked index + 1)
      if (textRef.current && textRef.current.value) {
        sendFreeAnswersToRAT({
          cId: config.cId.value,
          npsValue: config.nps.checked + 1,
          formInputValue: textRef.current.value,
        });
      }
      // submit
      onSubmit();
    },
    [config.cId.value, config.nps.checked, onSubmit]
  );

  return (
    step >= 0 && (
      <StyledSurveyContainer>
        <Backdrop embedded={embedded} nps={props.nps} submit={props.submit} />
        <Form
          ref={formRef}
          onSubmit={onSubmit}
          content-type={'application/x-www-form-urlencoded'}
          method={'POST'}
          // embedded={embedded}
        >
          <Hidden
            state={state}
            dispatch={dispatch}
            embedded={embedded}
            desktop={desktop}
            {...props}
          />
          <WidgetSequence
            onSendClick={onSendClick}
            state={state}
            dispatch={dispatch}
            embedded={embedded}
            desktop={desktop}
            {...props}
          />
        </Form>
      </StyledSurveyContainer>
    )
  );
};

export default WidgetForm;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/widget/WidgetForm.js